<div class="card-box mx-2">
    <mat-card class="card front" id="hvr-bounce-in">
        <mat-card-content style="color:white;font-weight:200">
            <div class="pl-2" style="color:black">
                <i class="fa fa-pencil float-right" style="position:absolute;right:5px;z-index: 1;color:white;" (click)="edit()"></i>
                <p style="font-weight: 400;">
                    <span class="fa-icon-span">
                        <i class="fa fa-user fa-fw"></i>
                    </span>
                    {{contact_details.name}} {{contact_details.last_name}}
                </p>
                <p class="details" *ngIf="contact_details.em_contact_number">
                    <span class="fa-icon-span">
                        <i class="fa fa-phone fa-fw" style="font-size: 15px;"></i>
                    </span> {{contact_details.em_contact_number}}
                </p>
                <p class="details">
                    <span class="fa-icon-span">
                        <i class="fa fa-users fa-fw" style="font-size: 15px;"></i>
                    </span> {{contact_details.relationship_name}}
                </p>
                <p class="details" *ngIf="contact_details.email_id">
                    <span class="fa-icon-span">
                        <i class="fa fa-envelope fa-fw"></i>
                    </span> {{contact_details.email_id}}
                </p>
                <p class="details" *ngIf="contact_details.city">
                    <span class="fa-icon-span">
                        <i class="fa fa-map-marker fa-fw"></i>
                    </span> {{contact_details.city}}
                </p>
            </div>
        </mat-card-content>
    </mat-card>
</div>